export const onboardingWizardTestIds = {
  root: 'onboarding-wizard',
  close: 'onboarding-wizard-close',
  skip: 'onboarding-wizard-skip',
  channelCell: ( connectorId: string ): string => `onboarding-wizard-channel-${connectorId}`,
  connect: 'onboarding-wizard-connect',
  storeUrl: 'onboarding-wizard-store-url',
  apiKeyField: ( name: string ): string => `onboarding-wizard-apikey-${name}`,
  storeName: 'onboarding-wizard-store-name',
  recheck: 'onboarding-wizard-recheck',
  cancelWait: 'onboarding-wizard-cancel-wait',
  option: ( key: string ): string => `onboarding-wizard-option-${key}`,
  /** The honest line shown in place of a progress card when no run is attached. */
  progressNote: ( kind: string ): string => `onboarding-wizard-progress-note-${kind}`,
  /** Opt-in for the historical order seeding. Only rendered for connectors that
   *  can count what they are about to pull (`canImportOrderHistory`). */
  importOrders: 'onboarding-wizard-import-orders',
  finish: 'onboarding-wizard-finish'
} as const;
